import { WFRoute, navigate } from "@xatom/core";
import { getUser, userMiddleware } from "../modules/auth";
import { globalVars } from "../modules/dashboard/globalVars";

export const app = () => {
  const token = localStorage.getItem(globalVars.LSKeys.userToken);

  // Show login page if token is not found
  new WFRoute(globalVars.pagesPaths.login).execute(() => {
    if (token) {
      navigate("/users/" + getUser().userPageSlug);
      return;
    }

    import("../modules/auth/login")
      .then(({ HandleLogin }) => new HandleLogin())
      .catch(console.error);
  });

  // Show login page if token is not found
  new WFRoute(globalVars.pagesPaths.support).execute(() => {
    if (token) {
      import("../modules/auth/support")
        .then(({ loadSupport }) => loadSupport())
        .catch(console.error);
      return;
    }

    navigate(globalVars.pagesPaths.login);
  });

  // Show user page if token is found
  new WFRoute("/users/(.*)").execute(() => {
    if (!token) {
      navigate(globalVars.pagesPaths.login);
      return;
    }

    import("../modules/dashboard")
      .then(({ Dashboard }) => new Dashboard())
      .catch(console.error);
  });
};
